/*
 * @Author: 丨小小风离丨
 * @Date: 2024-01-03 16:28:34
 * @LastEditTime: 2024-09-23 20:25:41
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\store\reducers\schoolInfo.ts
 * @Description: 
 */
import { createSlice } from '@reduxjs/toolkit';

interface DataState {
  schoolInfo: any
  schoolId: String
  schoolLevel: any
  aboutUs: any[]
}

const initialState: DataState = {
  schoolInfo: {},
  schoolId: '',
  schoolLevel: null, // 1=大学，2=中小学，3=高职，4=中职
  aboutUs: []
};

const dataSlice = createSlice({
  name: 'schoolInfo',
  initialState,
  reducers: {
    setSchoolInfo: (state: DataState, action) => {
      state.schoolInfo = action.payload;
    },
    setSchoolId: (state: DataState, action) => {
      state.schoolId = action.payload;
    },
    setSchoolLevel: (state: DataState, action) => {
      state.schoolLevel = action.payload;
    },
    setAboutUs: (state: DataState, action) => {
      state.aboutUs = action.payload;
    },
  },
  extraReducers: (builder) => {
  }
});

export const {
  setSchoolInfo,
  setSchoolId,
  setSchoolLevel,
  setAboutUs,
} = dataSlice.actions;

export const selectSchoolInfo = (state: any) => state?.schoolInfo?.schoolInfo;
export const selectSchoolId = (state: any) => state?.schoolInfo?.schoolId;
export const selectSchoolLevel = (state: any) => state?.schoolInfo?.schoolLevel;
export const selectAboutUs = (state: any) => state?.schoolInfo?.aboutUs;

export default dataSlice.reducer;
